import React from 'react';
import './Table.css';

export const getTotal = (data, schema) => {
    if(!data || !Array.isArray(data)) return {};
    const total={};
    schema.filter(r=>r.b).forEach(r=>{
        total[r.f] = 0;
    });

    data.forEach(r=>{
        const fields = Object.keys(r);
        fields.forEach(field=>{
            if(total.hasOwnProperty(field) ) total[field] += r[field];
        });        
    });

    const title_field = schema.find(r=>r.btitle);
    if (title_field) {
        total[title_field['f']] = 'Разом:';
    }

    return total;
}

export const Total = (props) => (
    <tr className="table-total-row">
        {props.schema.map((r, index) => (
            <td key={index} scope="col">{props.total[r.f]}</td>
        ))}
    </tr>
);

export const Headers = (props) => (
    <tr>
        {props.schema.map((r, index) => (
            <th key={index} scope="col" title={r.t}>{r.h}</th>
        ))}
    </tr>
);

export const ButtonsBlock = (props) => <div></div>;

export const Row = (props) => (
    <tr>
        {props.schema.map((r, index) => (
            <td key={index}>{props.d[r.f]}</td>
        ))}
    </tr>
);
